import { useMemo } from 'react';
import b from 'base-64';
import useKls from './useKls';
/**
 * Custom React Hook that returns the decoded klsk and dhp from the storage in the `AuthContext` object
 */
var useKlskDhp = function () {
    var kls = useKls();
    return useMemo(function () {
        try {
            var klsk = JSON.parse(b.decode(kls.klo));
            return { klsk: klsk.a, dhp: klsk.b };
        }
        catch (err) {
            return { klsk: [], dhp: null };
        }
    }, [kls]);
};
export default useKlskDhp;
//# sourceMappingURL=useKlskDhp.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hilma/auth/dist/hooks/useKlskDhp.js
// module id = 115
// module chunks = 1